import scoreConfig from "../utils/scoreConfig.json";

export const PREVIOUS_REFER_POINT_KEY = "previousReferPoint";
export const MASTER_WALLET_ADDRESS = {
  DEPOSIT_TASK: scoreConfig.master_address.deposit_task,
};
